export const environment = {
  production: false,
  apiUrl: 'https://backoffice-client.rancher.codefabrik.dev',
  // apiUrl: 'http://localhost:3003',
  websocketUrl: 'wss://backoffice-client.rancher.codefabrik.dev/socket/message',
  // websocketUrl: 'wss://localhost:3003/socket/message',
  encrypt_key: '9d34d243-9e7b-43fa-b77c-dd62ee97aac5',
  // encrypt_key: '478fc3c1-8a45-40e3-b1c8-3a613101771f',
  fingerprint_key: 'NvPNMN8Iyg2J83VWH08M',
};